module.exports = __webpack_public_path__ + "a63258f08effd7fb74fe5ae46e8d2c05.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/WW-AUS.svg
// module id = 8Co0
// module chunks = 0